<template>
  <b-container class="mb-3">
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="6" sm="12" class="mt-2">
          <div style="padding: 10px;border: 2px solid #c4c6be;border-radius: 15px;">
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Bank Name*"
              label-size="sm"
              label-for="inpbankName"
            >
              <b-form-input
                id="inpbankName"
                type="text"
                v-model="form.UserBankDetails.BankName"
                size="sm" required
                placeholder="bank name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Branch Name*"
              label-size="sm"
              label-for="inpbranchName"
            >
              <b-form-input
                id="inpbranchName"
                type="text"
                v-model="form.UserBankDetails.BranchName"
                size="sm" required
                placeholder="branch name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="City*"
              label-size="sm"
              label-for="inpCity"
            >
              <b-form-input
                id="inpCity"
                type="text"
                v-model="form.UserBankDetails.City"
                size="sm" required
                placeholder="city"
              ></b-form-input>
            </b-form-group>
            <!-- <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Has bank accepted your application?"
              label-size="sm"
              label-cols="5"
              label-for="radiosba"
            >
              <b-form-radio-group id="radiosba" v-model="form.UserBankDetails.BankAccept">
                <b-form-radio value="true">Yes</b-form-radio>
                <b-form-radio value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group> -->
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Comment"
              label-size="sm"
              label-for="inpComment"
            >
              <b-form-input
                id="inpComment"
                type="text"
                v-model="form.UserBankDetails.Comment"
                size="sm" required
                placeholder="comment"
              ></b-form-input>
            </b-form-group>
            <!-- <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Have You received Sanction Letter?"
              label-size="sm"
              label-cols="5"
              label-for="radiosba"
            >
              <b-form-radio-group
                id="radiosba"
                v-model="form.UserBankDetails.isApplication"
                v-on:change="onClickradio"
              >
                <b-form-radio value="true">Yes</b-form-radio>
                <b-form-radio value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group> -->
            <div id="isdata">
              <b-form-group
                id="exampleInputGroup2"
                horizontal
                label="Loan Tenure (Months)*"
                label-size="sm"
                label-for="inpTenure"
              >
                <b-form-input
                  id="inpTenure"
                  type="number"
                  min="1"
                  max="60"
                  v-model="form.UserBankDetails.Tenure"
                  size="sm" required
                  placeholder="Tenure"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup2"
                horizontal
                label="Rate of Interest % *"
                label-size="sm"
                label-for="inpRoi"
              >
                <b-form-input
                  id="inpRoi"
                  ref="roiInput"
                  type="number"
                  min="1.0"
                  max="12"
                  step="0.01"
                  v-model="form.UserBankDetails.Roi"
                  size="sm" required
                  placeholder="Rate of Interest %"
                  @input="onRoiInput"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup2"
                horizontal
                label="Loan Amount Rs.*"
                label-size="sm"
                label-for="inpAmount"
              >
                <b-form-input
                  id="inpAmount"
                  type="number"
                  min="100000"
                  max="1000000"
                  v-model="form.UserBankDetails.Amount"
                  size="sm" required
                  placeholder="Loan Amount Rs."
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="row">
              <div class="col-md-4">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem;"
                >Loan Sanction Letter *</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Provisional Sanction Letter NOT accepted</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiPhotoPath"
                  @change="onFileChange10"
                  v-if="form.UserBankDetails.sanctionLetter =='' || !form.UserBankDetails.sanctionLetter"
                  accept=".jpg, .png, .gif, .pdf"
                  size="sm"
                  required
                  v-model="Photo"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserBankDetails.sanctionLetter!='' && form.UserBankDetails.sanctionLetter">
                <a :href="getImgUrl2(form.UserBankDetails.sanctionLetter)" target="_blank">
                  <img style="height:30px" :src="getImgUrl(form.UserBankDetails.sanctionLetter)" class="img-fluid">
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('sanctionLetter', form.UserBankDetails.sanctionLetter)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2 justify-content-md-center" v-if="!getUser.LockProfile">
        <b-col md="4" sm="12" style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col md="5" sm="12" style="text-align:right">
          <b-button type="submit" variant="primary" :disabled="isLoading">{{ isLoading ? 'Saving...' : 'Submit' }}</b-button>
          <b-button type="reset" variant="danger" :disabled="isLoading">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="isSaved">Next</b-button>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-form>
    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>import { protectedDocumentUrl } from "@/services/tenantDocuments";

import apis from "@/apis";
import * as _ from "lodash";
import Spinner from "vue-simple-spinner";
import axios from "axios";

import lambda from "@/apis/lambda";

const _SheetJSFT = ["jpeg", "jpg", "png", "pdf"];
export default {
  components: { Spinner },
  data() {
    return {
      Photo: "",
      form: {
        UserBankDetails: {
          BankName: "",
          BranchName: "",
          City: "",
          BankAccept: "",
          Comment: "",
          Tenure: "",
          Roi: "",
          Amount: "",
          isApplication: false,
          sanctionLetter: ""
        },
        UserLoadDocumentUpload: {
          sanctionLetterStatus: false
        },
        LoginID: ""
      },
      isValue: false,
      isSaved: false,
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      modalInfo: "",
      selecteObj: {
        Document: "",
        Path: ""
      }
    };
  },
  methods: {
    onFileChange10(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiPhotoPath.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var filepath = "sanctionLetter_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then(response => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type
            }
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserBankDetails.sanctionLetter = filepath;
            this.form.UserLoadDocumentUpload.sanctionLetterStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onClickButton() {
      this.isSaved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      let promise = apis.saveLoanDocumentPath(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            if (this.docTbl.length > 0) {
              this.loadLoanImageList();
            }
            this.$refs.fiPhotoPath.reset();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },
    onClickradio(evt) {
      if (evt == "true") {
        document.getElementById("isdata").style.display = "block";
      } else {
        document.getElementById("isdata").style.display = "none";
      }
      this.isValue = evt;
      //console.log(evt);
    },
    deleteDocument2(document, path) {
      //console.log(item);
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let info = "You want to delete record for:" + "\n" + document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic)
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic)
        );
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.isLoading) return;
      this.showDismissibleAlert = false;
      this.isLoading = true;
      // if (!this.BankName) {
      //   this.alertText = "Please enter the Bank Name)";
      //   this.variant = "warning";
      //   this.showDismissibleAlert = true;
      //   this.isLoading = false;
      //   return;
      // }
      // if (!this.BranchName) {
      //   this.alertText = "Please enter the Branch Name)";
      //   this.variant = "warning";
      //   this.showDismissibleAlert = true;
      //   this.isLoading = false;
      //   return;
      // }
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      let promise = apis.saveBankDetails(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.isSaved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {},
    onRoiInput(value) {
      let raw = value === null || value === undefined ? '' : String(value).trim();
      if (raw === '') { this.form.UserBankDetails.Roi = ''; return; }
      let n = parseFloat(raw);
      if (isNaN(n)) n = 0;
      if (n < 0) n = 0;
      if (n > 12) n = 12;
      n = Math.round(n * 100) / 100;
      this.form.UserBankDetails.Roi = n;
      this.$nextTick(() => {
        let el = this.$refs.roiInput && this.$refs.roiInput.$el;
        if (el && el.value !== String(n)) el.value = n;
      });
    },
    getUserBankDetails() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadBankDetails(userinfo.UserId);

      promise
        .then(response => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.form.UserBankDetails = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  computed: {
    getUser() {
      let x = this.$store.getters.getUserData;
      let OrganizationName = "";
      let ProductfromOrganization = "";
      let OrganizationAddress = "";
      let AmountFromBank = 0;

      return {
        LockProfile: x.LockProfile || false
      };
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      this.getUserBankDetails();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/RegistrationLoan/BankDetailsForm.vue